import { useValue } from '@legendapp/state/react';
import { Text } from '@mantine/core';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { freeBetState$ } from '../state/free-bet.state';

export const FreeBetsInfo = () => {
  const { t } = useTranslation();

  const isFreeBetting = useValue(freeBetState$.isActive);
  const freeBetAmount = useValue(freeBetState$.bonusAmount);
  const freeBetCount = useValue(freeBetState$.bonusCount);

  const formatter = useMemo(
    () =>
      new Intl.NumberFormat('en-u-nu-latn', {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
        useGrouping: false,
      }),
    []
  );

  return isFreeBetting ? (
    <Text c="white" fw={500} size="sm" ta="right">
      {t('freeBetsInfo.labels.freeBets')}: {freeBetCount}x{' '}
      {formatter.format(freeBetAmount)}
    </Text>
  ) : null;
};
